import './App.css';
import React from 'react';
import NavBar from './Components/NavBar';
import Footer from './Components/Footer';
import Keystore from './Components/Keystore';
import Unlock from './Components/Unlock';
import Pem from './Components/Pem';
import RestoreKey from './Components/RestoreKey';
import Create from './Components/Create';
import Ledger from './Components/Ledger';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';




function App() {
  return (
    <div className="w-full flex flex-col justify-center">
      <NavBar />
      

      {/* Modals */}
      <div>
          <Routes>
            <Route path="/" element={<Unlock />} />
            <Route path="/keystore" element={<Keystore />} />
            <Route path="/pem" element={<Pem />} />
            <Route path="/recover" element={<RestoreKey />} />
            <Route path="/recover/password" element={<RestoreKey />} />
            <Route path="/recover/download" element={<RestoreKey />} />
            <Route path="/create" element={<Create />} />
            <Route path="/create/mnemonic" element={<Create />} />
            <Route path="/ledger" element={<Ledger />} />
          </Routes>
      </div>

      <Footer />
    </div>
  );
}

export default App;
